import { useCallback, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { ClienteDropDown } from '../domain/models/cliente_dropdown';

type Props = {
  name: string;
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined; 
  onChange: (newValue: string | number | undefined) => void; 
  error?: boolean;
  helperText?: string | null;
};

export const DefaultCliente = ({
  name,
  label,
  required,
  readOnly,
  placeholder,
  disabled,
  value,
  onChange,
  error,
  helperText,
}: Props) => {

  const { pushErrorNotification, pushInfoNotification } = usePageLoader();
  const [clienteDropDown, setClienteDropDown] = useState<ClienteDropDown[]>([]);

  const {
    commons: {
      getClientesDropDownUseCase,
    },
  } = useDependencyInjection();

  const loadFornecedorDropDown = useCallback(async () => {
    try {
      const result = await getClientesDropDownUseCase.getClientesDropDown();
      setClienteDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar Fornecedor!'));
    }
  }, [getClientesDropDownUseCase, pushErrorNotification]);

  usePageStartBootstrap(async () => {
    loadFornecedorDropDown();
  });


  return (
    <>
     <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={clienteDropDown}
        getOptionLabel={(opt) => String(opt.title)}
        isOptionEqualToValue={(opt, val) => String(opt.title) === String(val.title)} 
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled}
        value={clienteDropDown.find(x => String(x.id) === String(value)) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.id : undefined);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            required={required}
          />
        )}
      />
    </>
  );
};